import React from 'react'
import Header from '../components/Header'
import Footer from '../components/Footer'
import UniversityHeader from '../components/StudyingAboard/UniversityTution/UniversityHeader';
import UniversityInfo from '../components/StudyingAboard/UniversityTution/UniversityInfo';
import UniversityServiceIntro from '../components/StudyingAboard/UniversityTution/UniversityServiceIntro';
import Share from '../components/Share';
import SideOverlap from './sideOverlap';

export default function UniversityTution() {
    return (
        <>
            <Header />
            <UniversityHeader />
            <UniversityInfo />
            <UniversityServiceIntro/>
            <Share />
            <Footer />
            <SideOverlap />
        </>
    )
}